import wix from '../services/wix';

export const getChatSettings = ({ requestId }: { requestId: string }) => {
  return async function (dispatch, getState) {
    const requestName = 'ChatWidget.getChatSettings';
    const responseEventName = `${requestName}Response.${requestId}`;
    const chatVisibility =
      getState().visibilitySettings &&
      getState().visibilitySettings.publicVisibility;
    try {
      wix.publishToPubSub(responseEventName, {
        success: true,
        results: {
          isSocialChat: getState().socialChatEnabled && chatVisibility,
          isBusinessChat: getState().businessChatEnabled && chatVisibility,
        },
      });
    } catch (e) {
      wix.publishToPubSub(responseEventName, { success: false });
    }
  };
};
